import { render, staticRenderFns } from "./Lang.vue?vue&type=template&id=2d4f62fc&scoped=true"
import script from "./Lang.vue?vue&type=script&lang=js"
export * from "./Lang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4f62fc",
  null
  
)

export default component.exports